import mime from "mime";

export const getFileNameWithExtension = (
	fileName: string,
	mimeType: string,
): string => {
	const hasKnownExtension =
		fileName.includes(".") && mime.getType(fileName) !== null;
	if (hasKnownExtension) return fileName;

	const extension = mime.getExtension(mimeType);

	return extension ? `${fileName}.${extension}` : fileName;
};
